import { axiosClient } from "./axiosClient"

export const ORDER_PATH = '/api/v1/order'

export const addOrder = (body) => {
    return axiosClient.post(ORDER_PATH, body)
}

export const updateOrder = (id, body) => {
    return axiosClient.put(`${ORDER_PATH}/${id}`, body)
}

export const deleteOrder = (id) => {
    return axiosClient.delete(`${ORDER_PATH}/${id}`)
}

export const getOrderById = (id) => {
    return axiosClient.get(`${ORDER_PATH}/${id}`)
}

// Aynı tarihli siparişlerin sayfalar arasında atlanmaması için tarih ile birlikte id'ye göre de sıralanır
export const getPageOrders = ({ page = 0, id = "", customerId = '', orderDate = '', invoiceNumber = '', productId = '', boilerCode = '' }) => {
    return axiosClient.get(`${ORDER_PATH}/page?page=${page}&sort=orderDate,desc&sort=id,desc&id=${id}&customerId=${customerId}&orderDate=${orderDate}&invoiceNumber=${invoiceNumber}&productId=${productId}&boilerCode=${boilerCode}`)
}

export const chargeOrder = (id) => {
    return axiosClient.put(`${ORDER_PATH}/charge/${id}`)
}

export const dechargeOrder = (id) => {
    return axiosClient.put(`${ORDER_PATH}/decharge/${id}`)
}

export const downloadOrderReceipt = (id) => {
    return axiosClient.get(`${ORDER_PATH}/download-receipt/${id}`, {
        responseType: 'arraybuffer',
    })
}

export const downloadNewOrderReceipt = (id) => {
    return axiosClient.get(`${ORDER_PATH}/download-new-receipt/${id}`, {
        responseType: 'arraybuffer',
    })
}

export const uploadOrderExcelFile = (body) => {
    return axiosClient.post(`${ORDER_PATH}/upload-excel`, body)
}
